import type { Theme } from "@mui/material";

/** Near-white holiday bars with a soft edge so they read on white calendar cells. */
export const SCHEDULE_HOLIDAY_BG_LIGHT = "#F1F5F9";
export const SCHEDULE_HOLIDAY_BORDER_LIGHT = "#E2E8F0";
export const SCHEDULE_HOLIDAY_TEXT_LIGHT = "#000000";
/** Muted bar on dark calendar surfaces. */
export const SCHEDULE_HOLIDAY_BG_DARK = "#F1F5F9";
export const SCHEDULE_HOLIDAY_TEXT_DARK = "#000000";

export const SCHEDULE_TODAY_CELL_COLOR_LIGHT = "#BBC9CC";
export const SCHEDULE_TODAY_CELL_COLOR_DARK = "#687071";

export function getHolidayEventColor(theme: Pick<Theme, "palette">): string {
  return theme.palette.mode === "light" ? SCHEDULE_HOLIDAY_BG_LIGHT : SCHEDULE_HOLIDAY_BG_DARK;
}

export function getHolidayLabelTextColor(theme: Pick<Theme, "palette">): string {
  return theme.palette.mode === "light" ? SCHEDULE_HOLIDAY_TEXT_LIGHT : SCHEDULE_HOLIDAY_TEXT_DARK;
}

export function getTodayCellColor(theme: Pick<Theme, "palette">): string {
  return theme.palette.mode === "light"
    ? SCHEDULE_TODAY_CELL_COLOR_LIGHT
    : SCHEDULE_TODAY_CELL_COLOR_DARK;
}
